import React, {Component} from "react";
import {connect} from "react-redux";
import 'moment-timezone';
import {withTranslation} from "react-i18next";

import {fetchLotto6RecentDraw} from "../../store/rootAction";
import {JackpotValue} from "../jackpot/JackpotValue";
import {getShortBetType} from "../../utils/tickets/printUtils";
import RefreshButton from "../../utils/RefreshButton";

class DrawResult extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const {t, lastDraws} = this.props;
        return (
            <>
                {
                    lastDraws.length > 0 ? <>

                            <div
                                className="col no-padding-div header-div-title header-text header-div-blue-light block-header ">
                                <span className="text-black kh-font-bold">{t("labels:common.lastGame")}</span>
                                <RefreshButton
                                    onClick={() => {
                                        this.setState({imageResultRotate: "rotate"})
                                        this.props.fetchLotto6RecentDraw()
                                            .then(() => {
                                                setTimeout(() => {
                                                    this.setState({imageResultRotate: ""})
                                                }, 300)
                                            }).catch(() => {
                                            setTimeout(() => {
                                                this.setState({imageResultRotate: ""})
                                            }, 300)
                                        })
                                    }}
                                    className={this.state.imageResultRotate}
                                />
                            </div>

                            <div className="col no-padding-div header-div-title header-text header-div-white ">
                                <table className="table fade-in">
                                    <tbody>
                                    {
                                        lastDraws.map((item, index) => {
                                            const {drawLabel, oddEvenCode, underOverCode, result, number, isJackpot} = item;
                                            return (
                                                <tr className="fade-in table-draw-result" key={index}>
                                                    <td className="text-left font-weight-bold w-last-draw">{drawLabel}</td>
                                                    <td className="text-left font-weight-bold"><span
                                                        className={"kh-font-bold left-bet-type-" + underOverCode}>{t("labels:betPrefix.S_" + getShortBetType(underOverCode))}
                                                    </span><span> | </span>
                                                        <span
                                                            className={"kh-font-bold left-bet-type-" + oddEvenCode}>{t("labels:betPrefix." + oddEvenCode)}
                                                    </span><span> | </span>
                                                        <span
                                                            className={"kh-font-bold left-bet-type-" + number}> {t("labels:ticket.number")} {t("labels:betPrefix." + number)}​</span>
                                                        <span>   </span>{isJackpot ? <JackpotValue {...item}/> : ""}
                                                        <span> | </span><b>{result}</b>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </>
                        : null
                }
            </>
        );
    }
}

const mapStateToProps = state => ({
    lastDraws: state.lotto6.lastDraws
})

const mapDispatchToProps = dispatch => ({
    fetchLotto6RecentDraw: payload => dispatch(fetchLotto6RecentDraw(payload)),
});

export default withTranslation()(connect(
    mapStateToProps,
    mapDispatchToProps
)(DrawResult));
